var map = {
	"./bsc.png": "ceaf",
	"./bscscan.png": "ff9f",
	"./eth.png": "b71f",
	"./etherscan.png": "cec3",
	"./polygon.png": "75b5",
	"./polygonscan.png": "bf2f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9007";